// extracted by mini-css-extract-plugin
module.exports = {"HeroTitle":"styles_HeroTitle__szwdg","suptitle":"styles_suptitle__9Zj7c","title":"styles_title__rNK40"};